import { NewInvitationOutDto, NewInvitationInDto } from '../../../types/invitation.dto'

export const NEW_INVITATION = 'NEW_INVITATION'
export const NEW_INVITATION_SUCCESS = 'NEW_INVITATION_SUCCESS'
export const NEW_INVITATION_ERROR = 'NEW_INVITATION_ERROR'
export const RESET_NEW_INVITATION = 'RESET_NEW_INVITATION'

export interface NewInvitation {
  type: typeof NEW_INVITATION
  payload: NewInvitationOutDto
}

export interface NewInvitationSuccess {
  type: typeof NEW_INVITATION_SUCCESS
  payload: NewInvitationInDto
}

export interface NewInvitationError {
  type: typeof NEW_INVITATION_ERROR
  payload: string | boolean
}

export interface ResetNewInvitation {
  type: typeof RESET_NEW_INVITATION
  payload: null
}

export interface State {
  data: NewInvitationInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions = NewInvitation | NewInvitationSuccess | NewInvitationError | ResetNewInvitation
